import ApiService from '@/services/api.service'

export default {
  namespaced: true,
  state: {
    categories: [],
    products: [],
  },
  getters: {
    selectorItems: (state) => {
      return [].concat(state.categories, state.products).filter((item) => {
        return item.in_selector
      }).sort((a,b) => {
        return a.in_selector - b.in_selector
      })
    },
    productItems: (state) => { return (categoryId) => {
      return state.products.filter((item) => {
        return item.product_category_id == categoryId
      })}
    },
  },
  mutations: {
    setCategories(state, categories) {
      state.categories = categories.map((item) => {
        item.type = 'category'
        return item
      })
    },
    setProducts(state, products) {
      state.products = products.map((item) => {
        item.type = 'product'
        return item
      })
    },
  },
  actions: {
    fetchCategories({ commit }) {
      return ApiService.index(`/product-categories`, null)
        .then(items => {
          commit('setCategories', items)
          return Promise.resolve(items)
        })
    },
    fetchProducts({ commit }) {
      return ApiService.index(`/products`, null)
        .then(items => {
          commit('setProducts', items)
          return Promise.resolve(items)
        })
    },

  },


}
